import { render, staticRenderFns } from "./received-inve.vue?vue&type=template&id=1c681421&"
import script from "./received-inve.vue?vue&type=script&lang=js&"
export * from "./received-inve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports